import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { promptPwaInstall, subscribeToInstallPrompt } from '@/lib/pwa';

export const PwaInstallBanner: React.FC = () => {
  const [canInstall, setCanInstall] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToInstallPrompt((installable) => {
      setCanInstall(installable);
    });
    return () => unsubscribe();
  }, []);

  if (!canInstall || dismissed) return null;

  return (
    <aside aria-label="Install App Banner" className="bg-slate-900 text-white px-4 py-2.5 flex items-center justify-between shadow-md text-xs sm:text-sm border-b border-slate-700">
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-emerald-500 animate-ping" />
        <span>Install <strong>VSB Farm</strong> on your Android/mobile device for quick offline-ready barn operations.</span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="default"
          className="h-7 text-xs px-2.5 py-1 bg-emerald-700 hover:bg-emerald-600"
          onClick={async () => {
            await promptPwaInstall();
          }}
        >
          <Download className="w-3.5 h-3.5 mr-1" /> Install App
        </Button>
        <button
          onClick={() => setDismissed(true)}
          className="text-slate-400 hover:text-white p-1 rounded-sm"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </aside>
  );
};
